import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Form, Input, Item, Label } from 'native-base';

class BlockInput extends Component {
  handlerChange = (value, element) => {
    const { block, onChange } = this.props;

    onChange && onChange({
      block,
      element,
      value
    });
  }

  render() {
    const { block, value, keyboardType } = this.props;

    return (
      <><Form>
        {block.elements.map(element => <Item
          key={1}
          stackedLabel
          underline={false}
        >
          <Label>{element.label}</Label>
          <Input
            style={{ width: "100%" }}
            keyboardType={keyboardType || "default"}
            value={value}
            onChangeText={text => this.handlerChange(text, element)}
          />
        </Item>
        )}
      </Form>
      </>
    );
  }
}

BlockInput.propTypes = {
  block: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.string,
  keyboardType: PropTypes.string
};

export default BlockInput;